<script>
import { VDataTable } from 'vuetify/lib';
import { merge } from 'lodash';

const getPresentation = headers => {
  var scopedSlots = {};
  headers
    .filter(header => header.presentWith)
    .forEach(header => {
      scopedSlots[`item.${header.value}`] = props =>
        header.presentWith(props.value);
    });
  return scopedSlots;
};

export default {
  functional: true,
  name: 'BDataTable',
  props: {
    ...VDataTable.options.props,
    isClickable: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    apiGetRequestPending: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    }
  },
  render(createElement, context) {
    const customData = {
      class: [
        'b-data-table',
        {
          'b-data-table--clickable': context.props.isClickable,
          'b-data-table--hide-header': context.props.hideDefaultHeader,
          'b-data-table--disabled': context.props.disabled,
          'b-data-table--bordered': context.props.bordered
        }
      ],
      props: {
        hideDefaultFooter: true,
        fixedHeader: true,
        multiSort: true,
        itemsPerPage: context.props.items.length,
        noDataText: 'Keine Daten vorhanden',
        noResultsText: 'Keine Ergebnisse',
        disableSort: context.props.disabled,
        disableFiltering: context.props.disabled
      },
      scopedSlots: getPresentation(context.props.headers)
    };

    context.data.props = context.props;
    merge(context.data, customData);
    context.data.props.headers = context.data.props.headers.filter(
      header => !header.hide
    );

    return createElement(VDataTable, context.data);
  }
};
</script>

<style lang="scss">
.b-data-table {
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &.b-data-table--clickable {
    tr {
      cursor: pointer;
    }
  }

  &.b-data-table--hide-header {
    border-radius: 0px;

    & tbody > tr:first-child > td {
      border-top: 2px solid var(--v-border0-base) !important;
    }
  }

  &.b-data-table--disabled {
    opacity: 0.6;
  }

  &.b-data-table--bordered {
    border-radius: 0;
    border: 1px solid rgba(0, 0, 0, 0.87);
  }

  & td {
    font-size: 14px;
    font-weight: 500;
    color: var(--v-secondary-base);
  }

  &.theme--light.v-data-table th {
    font-size: 14px;
    font-weight: 500;
    color: var(--v-secondary-base);
  }

  &.theme--light.v-data-table {
    tbody {
      tr {
        &:not(:last-child) td {
          border-bottom: 2px solid var(--v-border0-base) !important;
        }
        &:hover {
          background: var(--v-border0-base) !important;
        }
        td:first-child {
          padding-left: 32px;
        }

        td:last-child {
          padding-right: 32px;
        }
      }
    }

    thead {
      & th {
        box-shadow: inset 0 -2px 0 var(--v-border0-base);
        font-weight: bold;
        color: black;
      }
      & tr:last-child {
        th {
          border-bottom: none;

          &:first-child {
            padding-left: 32px;
          }

          &:last-child {
            padding-right: 32px;
          }
        }
      }
    }

    tbody {
      tr.ausgegraut {
        opacity: 0.6;
        background: #fefefe;
      }
    }

  }

  & .mdi-minus-box::before,
  .mdi-checkbox-marked::before {
    color: var(--v-primary-base);
  }
}
</style>
